module.exports = __webpack_public_path__ + "static/media/combination-male.1eb16f50.png";